import { useDispatch } from 'react-redux';

import useStore from '../../../../../hooks/useStore';
import { AboutFormData } from '../form/types';
import { formDataToUserInput } from '../form/utils';
import { updateRegistration } from '../../../../../store/registration/actions';
import { updateEtasjer } from '../etasjeUtils';

export const useAboutStateUpdate = () => {
  const dispatch = useDispatch();
  const store = useStore();

  const updateAboutState = (data: AboutFormData) => {
    const { detaljeringssteg, bygningsdetaljer } = store.getState().register.userInput;

    const userInput = formDataToUserInput(data);

    // This is a hack to generate floors in the client. This should be moved to backend.
    const currentEtasjer = bygningsdetaljer.etasjer;
    const hasHeatedBasement = !!bygningsdetaljer.heleEllerDelerAvKjellerErOppvarmet;

    userInput.bygningsdetaljer.etasjer = updateEtasjer(currentEtasjer, hasHeatedBasement, data);

    userInput.detaljeringssteg = detaljeringssteg;

    // Preserve userInput values from other steps.
    // Consider splitting state. This should not be a part of about step submit
    userInput.bygningsdetaljer.konstruksjonstetthet = bygningsdetaljer.konstruksjonstetthet;
    userInput.bygningsdetaljer.terrengskjerming = bygningsdetaljer.terrengskjerming;
    userInput.bygningsdetaljer.grunnforhold = bygningsdetaljer.grunnforhold;
    userInput.bygningsdetaljer.ytterDorer = bygningsdetaljer.ytterDorer;
    userInput.bygningsdetaljer.tak = bygningsdetaljer.tak;

    dispatch(updateRegistration({ userInput }));
  };

  return { updateAboutState };
};
